
const hsbmDialog = {
  state: {
    hsbmState: false,
    hsbmId: '',
    hsbmName: '',

    // hsbmInfoSet: '',  // 设置 核算部门 {id,name} 字符串
    hsbmInfo: '',  // 核算部门字符串 str
  },

  mutations: {
    SET_HSBMSTATE: (state, val) => {
      state.hsbmState = val
    },
    SET_HSBMID: (state, val) => {
      state.hsbmId = val
    },
    SET_HSBMNAME: (state, val) => {
      state.hsbmName = val
    },

    // 设置id
    // SET_HSBMINFOSET: (state, val) => {
    //   state.hsbmInfoSet = val
    // },
    SET_HSBMINFO: (state, val) => {
      state.hsbmInfo = val
    }
  },
  actions: {}
}
export default hsbmDialog
